<template>

  <div class="wardrobe-main l_wrap" style="padding-bottom: 0;">

    <div class="wardrobe-divided-title l_flipped-mobile">
      <p class="wardrobe-spec-title" v-if="item.valid && builder.quoteIsViewable" v-html="builder.displayPriceIncludeGst(item.total)"></p>
    </div>

    <div class="features s_open l_quote">
      <div class="features-body">
        <div class="features-body-inner l_flex" style="align-items: stretch;" :class="{ 'l_flex-wrap' : props.item.sections == 3 }">



          <div
            class="opt l_visual l_interiors l_trio l_frameless l_config l_overview height--auto width--50">
            <div class="opt-inner">
              <div class="opt-tag">
                <span>Visual</span>
              </div>
              <div class="opt-image">
                <div class="opt-img" :style="`background-image: url(${props.item.data.layout.image});`" v-if="props.item.data.layout"></div>
                <div class="opt-img" :style="`background-image: url(${props.item.data.wallSpace.image});`" v-else></div>
              </div>
              <div class="opt-footer">
                <div>
                  <strong>{{ props.item.data.height.title }} </strong><br />
                  {{ props.item.data.top.title }} / Cornice: {{ props.item.data.corniceHeight.title }}
                </div>
              </div>
            </div>
          </div>

          <div
            class="opt l_visual l_interiors l_trio l_frameless l_config l_overview height--auto width--50">
            <div class="opt-inner">
              <div class="opt-tag">
                <span>Layout</span>
              </div>
              <div class="opt-image">
                <div class="opt-img">
                  <Plan
                    :item="props.item"
                    :layout="props.item.productLayout.slug"
                    :wallspace="props.item.data.wallSpace.slug"
                    :sections="props.item.sections"
                    :interactive="false"></Plan>
                </div>
              </div>
              <div class="opt-footer">
                <div>
                  <strong>{{ props.item.productLayout.title }}</strong><br />
                  <span v-html="props.item.data.wallSpace.title" v-if="props.item.data.wallSpace"></span>
                </div>
              </div>
            </div>
          </div>

          <template v-for="(section, index) in props.item.sections"
            v-bind:key="`${index}`">
            <button
              @click="lightboxActivate($event, props.item.data.sections[index].config)"
              :id="`kitchenSection${index}`"
              class="opt l_visual l_interiors l_trio l_frameless l_config l_overview"
              :class="{
                'height--auto width--50' : props.item.sections <= 2,
                'height--auto width--30' : props.item.sections >= 3,
              }">
              <div class="opt-inner">
                <div class="opt-tag">
                  <svg class="icon" v-if="section.configId"><use href="#check"></use></svg>
                  <span v-html="props.item.data.sections[index].title ?? builder.sectionTitles[index]"></span>
                </div>
                <div class="opt-image">
                  <div class="opt-img" :style="`background-image: url(${props.item.data.sections[index].config.image});`"></div>
                </div>
                <div class="opt-footer">
                  <div v-if="props.item.data.sections[index]">
                    <strong>{{ props.item.data.sections[index].config.title }}</strong>
                    <br />Width: {{ props.item.data.sections[index].width }}mm
                    <br />Doors: {{ props.item.data.sections[index].doors }}
                  </div>
                  <div v-else>To be selected<br />&nbsp;</div>
                </div>
              </div>
            </button>
          </template>

        </div>
      </div>
    </div>

  </div>

  <div class="wardrobe-main l_specs">

    <div class="wardrobe-specs">

      <div class="wardrobe-spec l_w100">
      <div class="wardrobe-spec-inner">

        <p class="wardrobe-spec-title">Design</p>

        <div class="wardrobe-spec-text">
          <div class="features s_open l_quote">
            <div class="features-body">
              <div class="features-body-inner l_flex l_stretch">

                <button
                  @click.stop="lightboxActivate($event, props.item.data.doorProfile)"
                  v-if="props.item.data.doorProfile"
                  class="opt l_visual l_interiors l_twoup l_frameless l_config l_overview l_selections-overview l_short l_doorprofile">
                  <div class="opt-inner">
                    <div class="opt-header">
                      <button class="opt-help">
                        <svg class="icon"><use xlink:href="#zoom"></use></svg>
                      </button>
                    </div>
                    <div class="opt-tag">
                      <span>Door Profile</span>
                    </div>
                    <div class="opt-image">
                      <div class="opt-img" :style="`background-image: url(${props.item.data.doorProfile.image});`"></div>
                    </div>
                    <div class="opt-footer">
                      <div v-if="props.item.data.doorProfile.title">
                        <strong v-html="props.item.data.doorProfile.title"></strong>
                        <br v-if="props.item.data.doorProfile.tag" /><span v-html="props.item.data.doorProfile.tag" v-if="props.item.data.doorProfile.tag"></span>
                      </div>
                      <div v-else>To be selected<br />&nbsp;</div>
                    </div>
                  </div>
                </button>

                <button
                  @click.stop="lightboxActivate($event, props.item.data.panel)"
                  v-if="props.item.data.panel"
                  class="opt l_visual l_interiors l_twoup l_frameless l_config l_overview l_selections-overview l_short">
                  <div class="opt-inner">
                    <div class="opt-header">
                      <button class="opt-help">
                        <svg class="icon"><use xlink:href="#zoom"></use></svg>
                      </button>
                    </div>
                    <div class="opt-tag">
                      <span>Panel Finish</span>
                    </div>
                    <div class="opt-image">
                      <div class="opt-img" :style="`background-image: url(${props.item.data.panel.image});`"></div>
                    </div>
                    <div class="opt-footer">
                      <div v-if="props.item.data.panel.title">
                        <strong v-html="props.item.data.panel.title"></strong>
                        <br /><span v-html="props.item.data.panel.subGroup.title"></span>
                      </div>
                      <div v-else>To be selected<br />&nbsp;</div>
                    </div>
                  </div>
                </button>

                <button
                  @click.stop="lightboxActivate($event, props.item.data.bench)"
                  v-if="props.item.data.bench"
                  class="opt l_visual l_interiors l_twoup l_frameless l_config l_overview l_selections-overview l_short">
                  <div class="opt-inner">
                    <div class="opt-header">
                      <button class="opt-help">
                        <svg class="icon"><use xlink:href="#zoom"></use></svg>
                      </button>
                    </div>
                    <div class="opt-tag">
                      <span>Benchtop Material</span>
                    </div>
                    <div class="opt-image">
                      <div class="opt-img" :style="`background-image: url(${props.item.data.bench.image});`"></div>
                    </div>
                    <div class="opt-footer">
                      <div v-if="props.item.data.bench.title">
                        <strong v-html="props.item.data.bench.title"></strong>
                        <br /><span v-html="props.item.data.bench.subGroup.title"></span>
                        <br />
                        <span>Benchtop Cuts Required: </span>
                        <span v-html="benchCutoutsDisplay(props.item.specs.benchCutouts)" v-if="props.item.specs"></span>
                      </div>
                      <div v-else>To be selected<br />&nbsp;</div>
                    </div>
                  </div>
                </button>

                <button
                  @click.stop="lightboxActivate($event, props.item.data.handles)"
                  class="opt l_visual l_interiors l_twoup l_frameless l_config l_overview l_selections-overview l_short">
                  <div class="opt-inner">
                    <div class="opt-header">
                      <button class="opt-help">
                        <svg class="icon"><use xlink:href="#zoom"></use></svg>
                      </button>
                    </div>
                    <div class="opt-tag">
                      <span>Handles</span>
                    </div>
                    <div class="opt-image">
                      <div class="opt-img" :style="`background-image: url(${props.item.data.handles.image});`" v-if="props.item.specs.requireHandles && props.item.data.handles"></div>
                      <div class="opt-img" v-else></div>
                    </div>
                    <div class="opt-footer">
                      <div v-if="props.item.specs.requireHandles && props.item.data.handles">
                        <strong v-html="props.item.data.handles.title" v-if="props.item.specs.requireHandles"></strong>
                        <br v-if="props.item.specs.requireHandles" />
                        <span v-if="props.item.specs.requireHandles">Handles Required: </span>
                        <span v-html="props.item.data.handlesQty" v-if="props.item.specs.requireHandles"></span>
                        <span v-else>Not required</span>
                      </div>
                      <div v-else-if="props.item.specs.requireHandles">To be selected<br />&nbsp;</div>
                      <div v-else>Handles not required<br />&nbsp;</div>
                    </div>
                  </div>
                </button>

                <button
                  @click.stop="lightboxActivate($event, props.item.data.hardware)"
                  class="opt l_visual l_interiors l_twoup l_frameless l_config l_overview l_selections-overview l_short">
                  <div class="opt-inner">
                    <div class="opt-header">
                      <button class="opt-help">
                        <svg class="icon"><use xlink:href="#zoom"></use></svg>
                      </button>
                    </div>
                    <div class="opt-tag">
                      <span>Hardware</span>
                    </div>
                    <div class="opt-image">
                      <div class="opt-img" :style="`background-image: url(${props.item.data.hardware.image});`" v-if="props.item.data.hardware"></div>
                      <div class="opt-img" v-else></div>
                    </div>
                    <div class="opt-footer">
                      <div v-if="props.item.data.hardware">
                        <strong v-html="props.item.data.hardware.title" v-if="props.item.data.hardware"></strong>
                        <span v-else>Not selected</span>
                      </div>
                      <div v-else>Not required<br />&nbsp;</div>
                    </div>
                  </div>
                </button>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>




      <template v-for="(section, index) in props.item.sections">

        <div class="wardrobe-specbreak"></div>

        <div class="wardrobe-spec l_w100" :class="{ 's_active' : showSectionSpecs(index) }">
          <button class="wardrobe-spec-inner" style="width: 100%; display: flex; align-items: center; justify-content: space-between;" @click="toggleSectionSpecs(index)">
            <strong v-if="props.item.data.sections[index].title" v-html="`${props.item.data.sections[index].title} Specifications`"></strong>
            <strong v-else>Section <span v-html="(index + 1)"></span> Specifications</strong>
            <svg class="icon l_flippable"><use href="#chevron-down"></use></svg>
          </button>
        </div>

        <div class="wardrobe-spec l_w60 l_toggle" :class="{ 's_active' : showSectionSpecs(index) }">
          <div class="wardrobe-spec-inner" style="padding-top: 0;">
            <p class="wardrobe-spec-title">Dimensions</p>
            <p class="wardrobe-spec-text">
              Width: <span class="l_light"><span v-html="props.item.data.sections[index].width"></span>mm</span><br />
              Doors: <span class="l_light"><span v-html="props.item.data.sections[index].doors"></span></span>
            </p>
            <!-- <p class="wardrobe-spec-title">Components</p> -->
            <div class="wardrobe-spec-text l_light l_itemised" style="margin-bottom: 20px;" v-html="props.item.data.sections[index].config.description"></div>
          </div>
        </div>

        <div class="wardrobe-spec l_w40 l_toggle" :class="{ 's_active' : showSectionSpecs(index) }">
          <div class="wardrobe-spec-inner" style="padding-top: 0;">

            <button @click.stop="lightboxActivate($event, props.item.data.sections[index].config)" class="opt l_static l_combo s_active">
              <div class="opt-inner">
                <div class="opt-header">
                  <div class="opt-title" v-html="props.item.data.sections[index].config.title"></div>
                  <div class="opt-help">
                    <svg class="icon"><use xlink:href="#zoom"></use></svg>
                  </div>
                </div>
                <div class="opt-image">
                  <div class="opt-img" :style="`background-image: url(${props.item.data.sections[index].config.image});`"></div>
                </div>
              </div>
            </button>

          </div>
        </div>

      </template>


      <div class="wardrobe-specbreak" v-if="props.item.includedItemsList"></div>

      <div class="wardrobe-spec" v-if="props.item.includedItemsList">
        <div class="wardrobe-spec-inner">
          <p class="wardrobe-spec-title">Additional Items</p>
          <p class="wardrobe-spec-text l_light l_itemised">
            <!-- <span class="l_text-blue">Board materials in white melamine</span><br /> -->
            <span v-html="props.item.includedItemsList"></span>
          </p>
        </div>
      </div>


      <div class="wardrobe-specbreak" v-if="props.item.adjusters && props.item.adjusters.length && props.item.valid"></div>

      <div class="wardrobe-spec" v-if="props.item.adjusters && props.item.adjusters.length && props.item.valid">
        <div class="wardrobe-spec-inner">
          <p class="wardrobe-spec-title">Custom Items</p>
          <p class="wardrobe-spec-text l_light">
            <span v-for="adjuster in props.item.adjusters">
              <span v-html="adjuster.title"></span>&nbsp;
              <span v-html="adjuster.totalCost"></span>
              <br />
            </span>
          </p>
        </div>
      </div>

    </div>

  </div>

  </template>

  <script setup>

  import { ref } from 'vue'

  var _ = require('lodash');

  const props = defineProps([
    'item'
  ])

  import { useBuilderStore } from "@/stores/builder";
  const builder = useBuilderStore();

  const emit = defineEmits(['selectOption'])

  const sectionSpecs = ref([]);

  function toggleSectionSpecs(index) {
    if (typeof sectionSpecs.value[index] == undefined) sectionSpecs.value[index] = true;
    sectionSpecs.value[index] = !sectionSpecs.value[index];
    console.log(sectionSpecs.value);
  }

  function showSectionSpecs(index) {
    if (typeof sectionSpecs.value[index] !== undefined && sectionSpecs.value[index]) return true;
    return false;
  }

  function lightboxActivate(e, item, zoomType) {
    emit('lightboxActivate', item, zoomType);
    e.preventDefault();
    return false;
  }
  </script>
